import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const BusinessContext = createContext();

export function BusinessProvider({ children }) {
  const [businesses, setBusinesses] = useState([]);
  const [currentBusiness, setCurrentBusiness] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchBusinesses();
  }, []);

  const fetchBusinesses = async () => {
    try {
      const response = await axios.get(`${API}/businesses`);
      if (response.data.success) {
        setBusinesses(response.data.businesses);
        // Default to "automotriz" if not already set
        const savedBusiness = localStorage.getItem("selectedBusiness");
        const defaultBusiness = response.data.businesses.find(
          b => b.id === (savedBusiness || "automotriz")
        );
        const selectedBusiness = defaultBusiness || response.data.businesses[0];
        setCurrentBusiness(selectedBusiness);
        console.log("Business context initialized:", selectedBusiness?.id);
      }
    } catch (error) {
      console.error("Error fetching businesses:", error);
      // Set default if API fails
      const defaultBusiness = {
        id: "automotriz",
        name: "HEBEH Automotriz",
        slug: "automotriz"
      };
      setCurrentBusiness(defaultBusiness);
      console.log("Business context fallback:", defaultBusiness.id);
    } finally {
      setLoading(false);
    }
  };

  const selectBusiness = (businessId) => {
    const business = businesses.find(b => b.id === businessId);
    if (business) {
      console.log("=== BUSINESS CHANGED ===");
      console.log("New business:", business.id, business.name);
      setCurrentBusiness(business);
      localStorage.setItem("selectedBusiness", businessId);
    }
  };

  // IMPORTANTE: No devolver un businessId hasta que currentBusiness esté definido
  const businessId = currentBusiness?.id || null;

  return (
    <BusinessContext.Provider 
      value={{ 
        businesses, 
        currentBusiness, 
        selectBusiness, 
        loading,
        businessId
      }}
    >
      {children}
    </BusinessContext.Provider>
  );
}

export function useBusiness() {
  const context = useContext(BusinessContext);
  if (!context) {
    throw new Error("useBusiness must be used within a BusinessProvider");
  }
  return context;
}

export default BusinessContext;
